import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Divider, IconButton, MenuItem, Checkbox, Grid, Select, FormControl, InputLabel, Dialog, DialogContent, FormControlLabel, Autocomplete, RadioGroup, Radio } from "@mui/material";
import * as Yup from "yup";
import DeleteIcon from "@mui/icons-material/Delete";
import '../../../../assets/ExtraStyle.css'
import { useFormik } from "formik";
import { AddNewQuestion, ApiAddChecklistQuestion, ApiGetChecklistCategoryList, ApiGetChecklistTemplateQuestions, ApiUpdateChecklistQuestion, ApiUpdateChecklistTemplateQuestion, ApiuploadDocuments, GetCategories, GetEntities, GetQuestions, UpdateQuestion } from "../../../../apiService/Core/Apicall.tsx";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import upload from '../../../../assets/images/upload.png'
import imageCompression from 'browser-image-compression';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ReactQuill from "react-quill-new";
import 'react-quill/dist/quill.snow.css';

import PatchedReactQuill from "../../ManageVenue/PatchedReactQuill.tsx";
import store from "../../../../global/config/store.ts";
import { setLoadingFalse, setLoadingTrue } from "../../../../global/config/Action/loadingActions.ts";
import { getChecklistQuestions } from "../../../../apiService/Core/ApiEndPoint.tsx";
import { ApiGetChecklistQuestions } from "../../../../apiService/Core/Apicall.tsx";

interface Option {
    id: number;
    text: string;
    commentEnabled: boolean;
    minCommentLength: string;
}
interface FormValues {
    question: string;
    // entityTypeId: number
    checklistCategoryId: number
    isPhotoRequire: boolean
    isCommentBox: boolean
    minPhoto: number
    // maxScore: number
    // displayOrder: 1
    // isScore: boolean
    // questionGroup: string
    questionDescription: string
    questionHint: string
    qType: string
    minChar: number
    createdBy: number
    // questionWeightage: number
    questionHintImages: string
    qOptionJson: Array<{
        optionId: number;
        value: string;
        optionScore: number;
        optionImage: number;
        optionComment: string;
        optionCommentType: string,
        optionCommentLabel: string,
        minChar: number;
        radioRatingComment: string;
        isPass: boolean;
    }>
}


const CreateNewChecklistQuestion: React.FC = () => {
    const location = useLocation();
    const { questionId } = useParams<string>()
    const [questionData, setQuestionData] = useState<any>(null)
    const [category, setcategorey] = useState<any>([])
    const [entity, setentity] = useState<any>('')
    const [ShowError, setShowError] = useState<boolean>(false)
    const [isConfirm, setisConfirm] = useState<boolean>(false)
    const [isCreateNew, setisCreateNew] = useState<boolean>(false)
    const [updatesingle, setupdatesingle] = useState<boolean>(false)
    const [uploadedimage, setuploadedimage] = useState<any[]>(questionData && questionData.questionHintImages ? questionData.questionHintImages.split(",") : [])
    const navigate = useNavigate()
    // console.log(" questionData?.qOptionJson",  questionData?.qOptionJson);
    useEffect(() => {
        const fetchquestionbank = async () => {
            if (!questionId) return
            try {
                const data = `?offset=0&limit=100&isActive=true&checklistQuestionId=${questionId}`
                const response = await ApiGetChecklistQuestions(data);
                setQuestionData(response.data);
                response.data?.questionHintImages?.length > 0 ?
                    setuploadedimage(response.data?.questionHintImages?.split(",") || []) :
                    setuploadedimage([])
            } catch (error: any) {
                toast.error(error);
            }
        };
        fetchquestionbank();
    }, [questionId]);

    const addOption = () => {
        const maxId = formik.values.qOptionJson.length > 0
            ? Math.max(...formik.values.qOptionJson.map((o: any) => o.optionId))
            : 0;
        formik.setFieldValue("qOptionJson", [
            ...formik.values.qOptionJson,
            {
                optionId: maxId + 1,
                value: '',
                optionScore: 0,
                optionImage: 0,
                optionComment: "no",
                radioRatingComment: "",
                optionCommentType: "",
                optionCommentLabel: '',
                minChar: 0
            }
        ]);
    };
    const parseHtmlToText = (htmlString: string) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        return doc.body.textContent || "";
    };
    useEffect(() => {
        const fetchcategory = async () => {
            try {
                const data = `?isActive=true`
                const categories = await ApiGetChecklistCategoryList(data)
                setcategorey(categories.data)
            }
            catch (error: any) {
                toast.error(error?.message || "something went wrong")
            }

        }
        const fetchentities = async () => {
            try {
                const entities = await GetEntities()
                setentity(entities.data)
            }
            catch (error: any) {
                toast.error(error?.message || "something went wrong")
            }
        }
        fetchcategory()
        fetchentities()
    }, [])

    const initialValues: FormValues = {
        question: (questionData ? parseHtmlToText(questionData?.question) : "") || '',
        // entityTypeId: (questionData?.entityTypeId?.entityTypeId) || 0,
        checklistCategoryId: (questionData?.checklistCategoryId?.checklistCategoryId) || 0,
        qType: (questionData?.qType) || 'R',
        // displayOrder: (questionData?.displayOrder) || 1,
        // maxScore: (questionData?.maxScore) || 0,
        questionDescription: (questionData?.questionDescription) || '',
        questionHint: (questionData?.questionHint) || '',
        // questionWeightage: (questionData?.questionWeightage) ?? 1,
        isPhotoRequire: (questionData?.isPhotoRequire) || false,
        isCommentBox: (questionData?.isCommentBox) || false,
        questionHintImages: (questionData?.questionHintImages) || '',
        minPhoto: (questionData?.minPhoto) || 0,
        // questionGroup: (questionData?.questionGroup) || '',
        // isScore: (questionData?.isScore) || false,
        minChar: (questionData?.minChar) || 0,
        createdBy: (questionData?.cretedBy) || 0,
        qOptionJson: questionData?.qOptionJson?.length > 2 ? JSON.parse(questionData?.qOptionJson) : [
            {
                optionId: 1,
                value: '',
                optionScore: 0,
                optionImage: 0,
                optionComment: "no",
                radioRatingComment: '',
                optionCommentLabel: '',
                optionCommentType: 'text',
                minChar: 0,
                isPass: true
            }
        ],
    };
    const validationSchema = Yup.object({
        question: Yup.string().required("Enter question name"),
        qType: Yup.string(),
        qOptionJson: Yup.array()
            .of(
                Yup.object().shape({
                    optionId: Yup.number().required("Option ID is required"),
                    value: Yup.string().test(
                        "required-value",
                        "Option Value is required",
                        function (value) {
                            const qType = this.options.context?.qType;

                            if (qType === "T") {
                                return true;
                            }

                            return !!value?.trim();
                        }
                    ),

                    score: Yup.number()
                        .typeError("Score must be a number")
                        .test("max-score", "Score must be less than max score", function (value) {
                            return value === undefined || value < formik.values.maxScore;
                        }),
                })
            )
            .when("qType", {
                is: "R",
                then: (schema) => schema.min(1, "At least one option is required"),
                otherwise: (schema) => schema.notRequired(),
            }),

    })
    useEffect(() => {
        if (category.length > 0 && !category.some((cat: any) => cat.checklistCategoryId === formik.values.checklistCategoryId)) {
            formik.setFieldValue("checklistCategoryId", category[0].checklistCategoryId);
        }
        // if (entity.length > 0 && !entity.some((ent:any) => ent.entityTypeId === formik.values.entityTypeId)) {
        //     formik.setFieldValue("entityTypeId", entity[0].entityTypeId);
        // }
    }, [category, entity]);
    const getFormattedOptions = (values: any) => {
        if (values.qType === "R") {
            return values.qOptionJson.map(({
                minChar,
                optionComment,
                optionId,
                optionImage,
                optionScore,
                optionCommentType,
                optionCommentLabel,
                value,
                isPass
            }: any) => ({
                minChar,
                optionComment,
                optionId,
                optionImage,
                optionScore,
                optionCommentType,
                optionCommentLabel,
                value,
                isPass
            }));
        } else if (values.qType === "C") {
            return values.qOptionJson.map(({ optionId, value, isPass }: any) => ({
                optionId,
                value,
                isPass
            }));
        } else if (values.qType === "r") {
            return values.qOptionJson.map(({
                minChar,
                optionComment,
                optionId,
                optionImage,
                optionScore,
                optionCommentType,
                optionCommentLabel,
                value,
                radioRatingComment,
                isPass
            }: any) => ({
                minChar,
                optionComment,
                optionId,
                optionImage,
                optionScore,
                optionCommentType,
                optionCommentLabel,
                value,
                radioRatingComment,
                isPass
            }));
        } else {
            return [];
        }
    };

    const cleanHtmlOrNull = (html?: string) => {
        if (!html) return null;

        const cleaned = html
            .replace(/^(<p>(<br>|&nbsp;|\s)*<\/p>)+/g, '')
            .replace(/(<p>(<br>|&nbsp;|\s)*<\/p>)+$/g, '')
            .trim();

        return cleaned === '' ? null : cleaned;
    };

    const onSubmit = async (values: FormValues) => {
        // const maxScore = Number(values.maxScore);

        const updatedValues = {
            ...values,
            ...(questionData ? { checklistQuestionId: questionId } : {}),
            ...(questionData ? { isActive: true } : {}),
            // ...(updatesingle ? clientEntityId ? { clientEntityId: clientEntityId } : venueId ? { venueId: venueId } : {} : {}),
            // ...((checklistTemplateQuestionId && checklistTemplateId) ? {checklistTemplateQuestionId: checklistTemplateQuestionId} : {}),
            // isScore: values.maxScore > 0,
            // maxScore: Number(values.maxScore),
            minChar: Number(values.minChar),
            minPhoto: Number(values.minPhoto),
            questionDescription: values?.questionDescription?.replace(/^(<p>(<br>|&nbsp;|\s)*<\/p>)+/g, '').replace(/(<p>(<br>|&nbsp;|\s)*<\/p>)+$/g, ''),
            questionHint: values?.questionHint?.replace(/^(<p>(<br>|&nbsp;|\s)*<\/p>)+/g, '').replace(/(<p>(<br>|&nbsp;|\s)*<\/p>)+$/g, ''),
            // questionWeightage: Number(values.maxScore) == 0 ? 0 : Number(values.questionWeightage),
            // questionWeightage: Number(values.questionWeightage),/
            // createdBy: Number(localStorage.getItem('createdBy')),
            isCommentBox: false,
            qOptionJson: getFormattedOptions(values),
            questionHintImages: uploadedimage.join(',')
        };
        // console.log("Update Data", updatedValues)
        const submitData = await (questionId ? ApiUpdateChecklistQuestion(updatedValues) : ApiAddChecklistQuestion(updatedValues))
        toast.success(submitData.message)
        navigate(-1)
    }
    const formik: any = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: true,
        enableReinitialize: true,
        onSubmit
    });


    // ----------------------------------------------------------File Upload ---------------------------------------
    const fileupload = async (filePath: any, fileType: any) => {
        // const userData: any = localStorage.getItem('userData');
        const formData = new FormData();
        // formData.append("userId", userData.userId);
        formData.append("fileType", fileType);
        formData.append("file", filePath); // Add a file
        try {
            const response: any = await ApiuploadDocuments(formData);
            if (response.status) {
                setuploadedimage([...uploadedimage, response.location])
                // formik.setFieldValue(fileType, response.location);
            }
        }
        catch (error) {
            // console.log(error)
        }

    }

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];

        if (file && file.type.startsWith("image/")) {
            try {
                store.dispatch(setLoadingTrue())
                const options = {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 800,
                    useWebWorker: true,
                };

                const compressedFile = await imageCompression(file, options);


                fileupload(compressedFile, 'question_hint_image');
            } catch (error) {
                console.error("Image compression failed:", error);
                alert("Image compression failed. Please try again.");
            }
            finally {
                store.dispatch(setLoadingFalse())
            }
        } else {
            alert("Please upload a valid image file.");
        }
    };

    const handleRemove = (indexToRemove: number) => {
        setuploadedimage(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    // const handlechnagemaxScore = (e) => {
    //     formik.setFieldValue('maxScore', e.target.value);
    // }
    return (

        <Box className="box-container1 extra" minHeight="calc(100vh - 180px)" p={3} >
            {/* Header */}
            < form onSubmit={formik.handleSubmit} >
                <Box className='d-flex justify-content-between align-items-center mb-2'>
                    <Typography variant="h6" >
                        {questionData ? "Update Question" : "Create New Question"}
                    </Typography>
                    <Button className="bg-grey transform px-5 text-light" type={"submit"} onClick={() => { setShowError(true); }}>
                        Save
                    </Button>
                </Box>

                <Divider className="w-100 my-2 mb-3" />

                <FormControl className="w-100 my-3 mt-4 ">
                    <InputLabel shrink={false}>Your Question</InputLabel>
                    <TextField
                        className="w-100"
                        placeholder="Write your Question here..."
                        variant="outlined"
                        fullWidth
                        value={formik.values.question}
                        onChange={(e) => formik.setFieldValue('question', e.target.value)}
                    />
                    {ShowError && formik.errors.question && <Typography className="text-danger">{formik.errors.question}</Typography>}

                </FormControl>

                <Box className="d-flex w-100 my-4 flex-wrap" gap='5px'>
                    <FormControl fullWidth className="w-33">
                        {/* <InputLabel id="demo-simple-select-label" shrink={false}>Category</InputLabel> */}
                        <Autocomplete
                            className="m-0 p-0"
                            options={category || []}
                            getOptionLabel={(option) => option.categoryName || ""}
                            value={
                                category.find(
                                    (cat: any) => cat.checklistCategoryId === formik.values.checklistCategoryId
                                ) || null
                            }
                            onChange={(event, newValue) => {
                                formik.setFieldValue(
                                    "checklistCategoryId",
                                    newValue ? newValue.checklistCategoryId : ""
                                );
                            }}
                            sx={{
                                "& .MuiInputBase-root": {
                                    padding: "0px !important",
                                    // minHeight: "2px",
                                },
                                "& .MuiAutocomplete-input": {
                                    padding: "10px 8px !important",
                                },
                                "& .MuiInputLabel-root": {
                                    top: '-35px !important'
                                }

                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    size="small"
                                    label="Select Category"
                                    error={
                                        formik.touched.checklistCategoryId &&
                                        Boolean(formik.errors.checklistCategoryId)
                                    }
                                    InputLabelProps={{
                                        shrink: false,
                                    }}
                                    helperText={
                                        formik.touched.checklistCategoryId &&
                                        formik.errors.checklistCategoryId
                                    }
                                />
                            )}
                            fullWidth
                        />
                        {/* <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={formik.values.checklistCategoryId}
                            onChange={(e) => formik.setFieldValue('checklistCategoryId', e.target.value)}
                        >
                            {category.length > 0 &&
                                category.map((cat) => (
                                    <MenuItem value={cat.checklistCategoryId} key={cat.checklistCategoryId}>
                                        {cat.categoryName}
                                    </MenuItem>
                                ))
                            }

                        </Select> */}
                    </FormControl>
                    {/* < FormControl fullWidth className="w-33">
                        <InputLabel id="demo-simple-select-label" shrink={false}>Business Type</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={formik.values.entityTypeId}
                            onChange={(e) => formik.setFieldValue('entityTypeId', e.target.value)}
                        >
                            {entity.length > 0 &&
                                entity.map((cat:any) => (
                                    <MenuItem value={cat.entityTypeId} key={cat.entityTypeId}>
                                        {cat.entityTypeName}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl> */}
                    < FormControl fullWidth className="w-33">
                        <InputLabel id="demo-simple-select-label3" shrink={false}>Answer Type</InputLabel>
                        <Select
                            labelId="demo-simple-select-label3"
                            id="demo-simple-select-label3"
                            value={formik.values.qType}
                            onChange={(e) => formik.setFieldValue('qType', e.target.value)}
                        >
                            <MenuItem value="R">Radio Selection</MenuItem>
                            <MenuItem value="T">TextBox</MenuItem>
                            <MenuItem value="C">CheckBox</MenuItem>
                            <MenuItem value="r">Radio Rating Box</MenuItem>
                        </Select>
                    </FormControl>
                    {/* < FormControl fullWidth className="w-33">
                        <InputLabel id="demo-simple-select-label" shrink={false}>Score</InputLabel>
                        <TextField onBlur={(e) => {
                            const value = parseInt(e.target.value, 10);
                            if (isNaN(value) || value < 0) {
                                toast.error('Number Should be positive')
                                formik.setFieldValue('maxScore', '0');
                            }
                        }} inputProps={{ min: 0 }} type="number" value={formik.values.maxScore} onChange={(e) => { handlechnagemaxScore(e) }} />
                    </FormControl> */}
                    {/* < FormControl fullWidth className="w-33">
                        <InputLabel id="demo-simple-select-label" shrink={false}>Question Weightage</InputLabel>
                        <TextField
                            // disabled={formik.values.maxScore == 0}
                            onBlur={(e) => {
                                const value = parseInt(e.target.value, 10);
                                if (isNaN(value) || value < 0) {
                                    toast.error('Number Should be more than Zero')
                                    formik.setFieldValue('questionWeightage', 1);
                                }
                            }}
                            inputProps={{ min: 0 }} type="number" value={formik.values.questionWeightage} onChange={(e) => { formik.setFieldValue('questionWeightage', e.target.value) }} />
                    </FormControl> */}
                    <FormControl className="w-33" fullWidth>
                        <InputLabel shrink={false}>
                            Will this question have an upload Image/File option?
                        </InputLabel>
                        <Select
                            {...formik.getFieldProps("isPhotoRequire")}
                            onChange={(event) => formik.setFieldValue("isPhotoRequire", event.target.value === "true")}
                            value={formik.values.isPhotoRequire}
                        >
                            <MenuItem value={"true"}>Yes</MenuItem>
                            <MenuItem value={"false"}>No</MenuItem>
                        </Select>
                    </FormControl>
                    {formik.values.isPhotoRequire === true && (
                        <FormControl fullWidth className="w-33">
                            <InputLabel shrink={false}>Minimum Number of Images to UploadInputLabel</InputLabel>
                            <TextField
                                onBlur={(e) => {
                                    const value = parseInt(e.target.value, 10);
                                    if (isNaN(value) || value < 0) {
                                        toast.error('Number Should be positive')
                                        formik.setFieldValue('minChar', '0');
                                    }
                                }}
                                inputProps={{ min: 0 }} type="number" value={formik.values.minPhoto} onChange={(e) => { formik.setFieldValue('minPhoto', e.target.value) }} />

                        </FormControl>
                    )}
                    {formik.values.qType === "T" && (
                        <FormControl fullWidth className="w-33">
                            <InputLabel shrink={false}>Min. Words for Comment</InputLabel>
                            <TextField
                                onBlur={(e) => {
                                    const value = parseInt(e.target.value, 10);
                                    if (isNaN(value) || value < 0) {
                                        toast.error('Number Should be positive')
                                        formik.setFieldValue('minChar', '0');
                                    }
                                }}
                                inputProps={{ min: 0 }} type="number" value={formik.values.minChar} onChange={(e) => { formik.setFieldValue('minChar', e.target.value) }} />

                        </FormControl>
                    )}
                    {/* <FormControl className="w-33" fullWidth>
                        <InputLabel shrink={false}>
                            Question Group
                        </InputLabel>
                        <Select
                            {...formik.getFieldProps("questionGroup")}
                            onChange={(event) => formik.setFieldValue("questionGroup", event.target.value)}
                            value={formik.values.questionGroup}
                            displayEmpty
                        >
                            <MenuItem value="">
                                None
                            </MenuItem>
                            <MenuItem value="M">Moments that matter</MenuItem>
                            <MenuItem value="C">Compliance</MenuItem>
                            <MenuItem value="L">Liquor</MenuItem>
                        </Select>
                    </FormControl> */}
                    {/* < FormControl fullWidth className="w-50">
                        <InputLabel id="demo-simple-select-label" shrink={false}>Description</InputLabel>
                        <TextField
                            value={formik.values.questionDescription} onChange={(e) => { formik.setFieldValue('questionDescription', e.target.value) }} />
                    </FormControl> */}
                    <FormControl fullWidth className="w-100 mb-5 d-block">
                        <label style={{ marginBottom: '8px', fontSize: '14px', fontWeight: 500 }}>Description</label>
                        {/* <ReactQuill
                            theme="snow"
                            value={formik.values.questionDescription}
                            onChange={(content) => formik.setFieldValue('questionDescription', content)}
                            modules={quillModules}
                            formats={quillFormats}
                            style={{ height: '150px' }}
                        /> */}
                        <PatchedReactQuill
                            setEditorValue={(content) => formik.setFieldValue('questionDescription', content)}
                            editorValue={formik.values.questionDescription}
                            isUpdate={false}
                        />
                    </FormControl>
                    {/* < FormControl fullWidth className="w-33">
                        <InputLabel id="demo-simple-select-label" shrink={false}>Hint</InputLabel>
                        <TextField
                            value={formik.values.questionHint} onChange={(e) => { formik.setFieldValue('questionHint', e.target.value) }} />
                    </FormControl> */}
                    <FormControl fullWidth className="w-100 mb-5 d-block">
                        <label style={{ marginBottom: '8px', fontSize: '14px', fontWeight: 500 }}>Hint</label>
                        {/* <ReactQuill
                            theme="snow"
                            value={formik.values.questionHint}
                            onChange={(content) => formik.setFieldValue('questionHint', content)}
                            modules={quillModules}
                            formats={quillFormats}
                            style={{ height: '150px' }}
                        /> */}
                        <PatchedReactQuill
                            setEditorValue={(content) => formik.setFieldValue('questionHint', content)}
                            editorValue={formik.values.questionHint}
                            isUpdate={false}
                        />
                    </FormControl>
                    <FormControl className="col-12">
                        <label htmlFor="file-upload" style={{ marginBottom: '8px', fontSize: '14px', fontWeight: 500 }} className='form-caption'>
                            <span>
                                Question Hint Images{" "}
                                <sup>
                                    <i className="fa-solid fa-star-of-life star"></i>
                                </sup>
                            </span>

                            <Box className='mt-2 d-flex align-items-center justify-content-center' height={300} width={{ xs: '100%', md: '300px !important' }} border='1px dashed #00000033' borderRadius={5}>
                                <input
                                    type="file"
                                    id="file-upload"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    onChange={handleFileChange}
                                />
                                <Box className='d-flex flex-column align-items-center justify-content-center'>
                                    <Box component='img' height={36} width={36} src={upload}></Box>
                                    <Typography className='form-caption'>Upload Here</Typography>
                                </Box>
                            </Box>
                        </label>
                    </FormControl>
                </Box>

                <Box className='mt-3 d-flex align-items-start' gap={2}>
                    {uploadedimage && uploadedimage.map((item, index) => (
                        <Box className="image-container" key={index} position="relative" width="fit-content">
                            <Box
                                component="img"
                                className="uploadedImg"
                                alt="img"
                                src={item}
                                height={300}
                                width="auto"
                            />
                            <Box className="cancel-button">
                                <CancelOutlinedIcon sx={{ color: 'black' }} onClick={() => handleRemove(index)}></CancelOutlinedIcon>
                            </Box>
                        </Box>
                    ))}
                </Box>
                {
                    (formik.values.qType === "R" || formik.values.qType === "r" || formik.values.qType === "C") && (
                        <>
                            <Box
                                width="100%"
                                sx={{
                                    borderBottom: "3px dashed #D3D3D3",
                                    opacity: 1,
                                    marginY: 2,
                                }}
                            />
                            <Box className='d-flex justify-content-between w-100 align-items-center my-2 mb-5'>
                                <Typography variant="h6" >
                                    Options for Answers
                                </Typography>
                                <Button
                                    onClick={addOption}
                                    className="bg-grey transform text-light px-4"
                                >
                                    + New Option
                                </Button>
                            </Box>
                            <Grid container spacing={4} className="optionsAnswers">
                                {formik.values.qOptionJson.map((option: any, index: number) => {
                                    const optionErrors = (formik.errors.qOptionJson?.[index] as any) || {};
                                    const optionTouched = (formik.touched.qOptionJson?.[index] as any) || {};
                                    return (

                                        <Grid item xs={12} sm={6} key={option.optionId + 1} sx={{ width: "48%" }}>
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="stretch"

                                                borderRadius="5px"
                                                border='1px solid #a3a3a3'
                                            >
                                                <Box className="d-flex align-items-stretch">
                                                    <FormControl fullWidth sx={{ "& fieldset": "0px !important" }}>
                                                        <InputLabel shrink={false}>Option - {index + 1}</InputLabel>
                                                        <TextField
                                                            value={parseHtmlToText(option.value)}
                                                            onChange={(e) => {
                                                                const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                    opt.optionId === option.optionId ? { ...opt, value: e.target.value } : opt
                                                                );
                                                                formik.setFieldValue("qOptionJson", updatedOptions);
                                                            }}
                                                            placeholder="Enter Option"
                                                            onBlur={() => formik.setFieldTouched(`qOptionJson[${index}].value`, true)}
                                                            error={optionTouched.value && !!optionErrors.value}
                                                        />
                                                        {ShowError && optionTouched.value && optionErrors.value && (
                                                            <Typography className="text-danger">{optionErrors.value}</Typography>
                                                        )}
                                                    </FormControl>

                                                    {formik.values.qType !== "C" && <Box gap={1} className="d-flex  bg-grey py-2 text-light px-4 align-items-center justify-content-between" width='auto'>
                                                        <Checkbox
                                                            checked={option.optionComment?.toLowerCase() === "yes"}
                                                            onChange={() => {
                                                                const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                    opt.optionId === option.optionId
                                                                        ? {
                                                                            ...opt, optionComment: opt.optionComment?.toLowerCase() === "yes" ? "" : "yes",
                                                                            optionCommentType: opt.optionComment?.toLowerCase() === "yes" ? "" : opt.optionCommentType
                                                                        }
                                                                        : opt
                                                                );
                                                                formik.setFieldValue("qOptionJson", updatedOptions);
                                                            }}
                                                            sx={{ color: "white", p: 0 }}
                                                        />
                                                        <Typography fontSize="14px" whiteSpace='nowrap'>Enable Comment</Typography>
                                                    </Box>}
                                                    {
                                                        index !== 0 && (
                                                            <IconButton
                                                                onClick={() => {
                                                                    const updatedOptions = formik.values.qOptionJson.filter(
                                                                        (opt: any) => opt.optionId !== option.optionId
                                                                    );
                                                                    formik.setFieldValue("qOptionJson", updatedOptions);
                                                                }}
                                                                className="bg-danger text-light p-2"
                                                                sx={{ borderRadius: "0px" }}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        )
                                                    }

                                                </Box>
                                                {formik.values.qType === "C" && (
                                                    // <FormControl className="normal-checkbox mx-2" sx={{ width: "100%" }}>
                                                    //     <FormControlLabel
                                                    //         control={
                                                    //             <Checkbox
                                                    //                 sx={{
                                                    //                     "&.Mui-checked": {
                                                    //                         color: "#1976d2 !important",
                                                    //                     },
                                                    //                 }}
                                                    //                 checked={option.isPass || false}
                                                    //                 onChange={(e) => {
                                                    //                     const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                    //                         opt.optionId === option.optionId
                                                    //                             ? { ...opt, isPass: e.target.checked }
                                                    //                             : opt
                                                    //                     );
                                                    //                     formik.setFieldValue("qOptionJson", updatedOptions);
                                                    //                 }}
                                                    //             />
                                                    //         }
                                                    //         label="is Pass?"
                                                    //     />
                                                    // </FormControl>
                                                    <FormControl className="normal-checkbox mx-2" sx={{ width: "100%" }}>
                                                        <RadioGroup
                                                            row
                                                            value={
                                                                option.isPass === true
                                                                    ? "pass"
                                                                    : option.isPass === false
                                                                        ? "fail"
                                                                        : "warn"
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                    opt.optionId === option.optionId
                                                                        ? {
                                                                            ...opt,
                                                                            isPass:
                                                                                value === "pass"
                                                                                    ? true
                                                                                    : value === "fail"
                                                                                        ? false
                                                                                        : null,
                                                                        }
                                                                        : opt
                                                                );

                                                                formik.setFieldValue("qOptionJson", updatedOptions);
                                                            }}
                                                        >
                                                            <FormControlLabel
                                                                value="pass"
                                                                control={<Radio color="success" />}
                                                                label="Pass"
                                                            />

                                                            <FormControlLabel
                                                                value="fail"
                                                                control={<Radio color="error" />}
                                                                label="Fail"
                                                            />

                                                            <FormControlLabel
                                                                value="warn"
                                                                control={<Radio color="warning" />}
                                                                label="Warn"
                                                            />
                                                        </RadioGroup>
                                                    </FormControl>
                                                )
                                                }

                                                {formik.values.qType !== "C" && <Box border="1px solid #ccc" className="w-100 p-2">
                                                    <Box className="w-100 mt-4 d-flex justify-content-start flex-wrap" gap={1}>

                                                        <FormControl sx={{ width: '32%' }}>
                                                            <InputLabel id="demo-simple-select-label" shrink={false}>Option Score</InputLabel>
                                                            <TextField
                                                                type="number"
                                                                onBlur={(e) => {
                                                                    const value = parseInt(e.target.value, 10);
                                                                    if (isNaN(value) || value < -1) {
                                                                        toast.error('Number Should be greater than -1')
                                                                        const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                            opt.optionId === option.optionId ? { ...opt, optionScore: 0 } : opt
                                                                        );
                                                                        formik.setFieldValue("qOptionJson", updatedOptions);

                                                                    }
                                                                    // else if (value > formik.values.maxScore) {
                                                                    //     toast.error('Option Score can not be greater than maxScore')
                                                                    //     const updatedOptions = formik.values.qOptionJson.map((opt) =>
                                                                    //         opt.optionId === option.optionId ? { ...opt, optionScore: 0 } : opt
                                                                    //     );
                                                                    //     formik.setFieldValue("qOptionJson", updatedOptions);


                                                                    // }
                                                                }}
                                                                inputProps={{ min: -1 }}
                                                                value={option.optionScore}
                                                                onChange={(e) => {
                                                                    const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                        opt.optionId === option.optionId ? { ...opt, optionScore: Number(e.target.value) || 0 } : opt
                                                                    );
                                                                    formik.setFieldValue("qOptionJson", updatedOptions);
                                                                }}
                                                                placeholder="Enter Score"
                                                                error={optionTouched.optionScore && !!optionErrors.optionScore}

                                                            />
                                                            {ShowError && optionTouched.optionScore && optionErrors.optionScore && (
                                                                <Typography className="text-danger">{optionErrors.optionScore}</Typography>
                                                            )}

                                                        </FormControl>
                                                        < FormControl sx={{ width: '32%' }}>
                                                            <InputLabel id="demo-simple-select-label" shrink={false}>Minimum Images</InputLabel>
                                                            <TextField
                                                                type="number"
                                                                onBlur={(e) => {
                                                                    const value = parseInt(e.target.value, 10);
                                                                    if (isNaN(value) || value < 0) {
                                                                        toast.error('Number Should be positive')
                                                                        const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                            opt.optionId === option.optionId ? { ...opt, optionImage: 0 } : opt
                                                                        );
                                                                        formik.setFieldValue("qOptionJson", updatedOptions);

                                                                    }
                                                                }}
                                                                inputProps={{ min: 0 }}
                                                                value={option.optionImage}
                                                                onChange={(e) => {
                                                                    const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                        opt.optionId === option.optionId ? { ...opt, optionImage: Number(e.target.value) || 0 } : opt
                                                                    );
                                                                    formik.setFieldValue("qOptionJson", updatedOptions);
                                                                }}
                                                                placeholder="Enter minimum numer of images"
                                                                error={optionTouched.optionImage && !!optionErrors.optionImage}

                                                            />
                                                            {ShowError && optionTouched.optionImage && optionErrors.optionImage && (
                                                                <Typography className="text-danger">{optionErrors.optionImage}</Typography>
                                                            )}

                                                        </FormControl>
                                                        {option.optionComment?.toLowerCase() === 'yes' && (
                                                            <>
                                                                <FormControl sx={{ width: '32%' }}>
                                                                    <InputLabel shrink={false} sx={{
                                                                        '&.MuiInputLabel-root': {
                                                                            fontSize: '12px !important',
                                                                            marginBottom: '0px'
                                                                        },
                                                                    }}
                                                                    >A MINIMUM OF ONE WORD REQUIRED</InputLabel>
                                                                    <TextField
                                                                        type="number"
                                                                        onBlur={(e) => {
                                                                            const value = parseInt(e.target.value, 10);
                                                                            if (isNaN(value) || value < 0) {
                                                                                toast.error('Number Should be positive')
                                                                                const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                                    opt.optionId === option.optionId
                                                                                        ? { ...opt, minChar: 0 }
                                                                                        : opt
                                                                                );
                                                                                formik.setFieldValue("qOptionJson", updatedOptions);

                                                                            }
                                                                        }}
                                                                        inputProps={{ min: 0 }}
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        value={option.minChar}
                                                                        onChange={(e) => {
                                                                            const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                                opt.optionId === option.optionId
                                                                                    ? { ...opt, minChar: Number(e.target.value) || 0 }
                                                                                    : opt
                                                                            );
                                                                            formik.setFieldValue("qOptionJson", updatedOptions);
                                                                        }}
                                                                        placeholder="50"
                                                                        error={optionTouched.minChar && !!optionErrors.minChar}

                                                                    />
                                                                    {ShowError && optionTouched.minChar && optionErrors.minChar && (
                                                                        <Typography className="text-danger">{optionErrors.minChar}</Typography>
                                                                    )}
                                                                </FormControl>
                                                                <FormControl className="w-33 mt-4 mb-0" >
                                                                    <InputLabel shrink={false}>
                                                                        Comment Type
                                                                    </InputLabel>
                                                                    <Select
                                                                        onChange={(e) => {
                                                                            const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                                opt.optionId === option.optionId ? { ...opt, optionCommentType: e.target.value || "" } : opt
                                                                            );
                                                                            formik.setFieldValue("qOptionJson", updatedOptions);
                                                                        }}
                                                                        value={option.optionCommentType}
                                                                    >
                                                                        <MenuItem value="text">Text</MenuItem>
                                                                        <MenuItem value="longText">Long Text</MenuItem>
                                                                        <MenuItem value="checkbox">CheckBox</MenuItem>
                                                                        <MenuItem value="time">Time</MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                                <FormControl className="mt-4" sx={{ width: 'calc(100% - 35%)' }}>
                                                                    <InputLabel shrink={false}>Comment Label</InputLabel>
                                                                    <TextField
                                                                        className="w-100"
                                                                        placeholder="Write your Question here..."
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        value={option.optionCommentLabel}
                                                                        onChange={(e) => {
                                                                            const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                                opt.optionId === option.optionId ? { ...opt, optionCommentLabel: e.target.value || '' } : opt
                                                                            );
                                                                            formik.setFieldValue("qOptionJson", updatedOptions);
                                                                        }} />
                                                                </FormControl>

                                                            </>
                                                        )}
                                                        <FormControl className="normal-checkbox mx-2" sx={{ width: "100%" }}>
                                                            <RadioGroup
                                                                row
                                                                value={
                                                                    option.isPass === true
                                                                        ? "pass"
                                                                        : option.isPass === false
                                                                            ? "fail"
                                                                            : "warn"
                                                                }
                                                                onChange={(e) => {
                                                                    const value = e.target.value;

                                                                    const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                        opt.optionId === option.optionId
                                                                            ? {
                                                                                ...opt,
                                                                                isPass:
                                                                                    value === "pass"
                                                                                        ? true
                                                                                        : value === "fail"
                                                                                            ? false
                                                                                            : null,
                                                                            }
                                                                            : opt
                                                                    );

                                                                    formik.setFieldValue("qOptionJson", updatedOptions);
                                                                }}
                                                            >
                                                                <FormControlLabel
                                                                    value="pass"
                                                                    control={<Radio color="success" />}
                                                                    label="Pass"
                                                                />

                                                                <FormControlLabel
                                                                    value="fail"
                                                                    control={<Radio color="error" />}
                                                                    label="Fail"
                                                                />

                                                                <FormControlLabel
                                                                    value="warn"
                                                                    control={<Radio color="warning" />}
                                                                    label="Warn"
                                                                />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Box>
                                                    {formik.values.qType === "R" || formik.values.qType === "r" && <FormControl fullWidth className="w-100" sx={{ marginTop: '30px' }}>
                                                        <InputLabel id="demo-simple-select-label" shrink={false}>Radio Rating Comment</InputLabel>
                                                        <TextField
                                                            type="text"
                                                            value={option.radioRatingComment}
                                                            onChange={(e) => {
                                                                const updatedOptions = formik.values.qOptionJson.map((opt: any) =>
                                                                    opt.optionId === option.optionId ? { ...opt, radioRatingComment: e.target.value || '' } : opt
                                                                );
                                                                formik.setFieldValue("qOptionJson", updatedOptions);
                                                            }}
                                                            placeholder="Enter Rating Comment"

                                                        />
                                                    </FormControl>}
                                                </Box>}

                                            </Box>
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </>
                    )
                }
                <Box
                    width="100%"
                    sx={{
                        borderBottom: "3px dashed #D3D3D3",
                        opacity: 1,
                        marginY: 2,
                        mt: 4
                    }}
                />
            </form >



        </Box >
    );
};

export default CreateNewChecklistQuestion;
